import { useStoreAnalytics } from '@/hooks/features/analytics'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { DeviceFunnelCard } from '../AnalyticsCards'
import { STEP_LABELS, titleClass } from '../constants'
import { JourneyChart, type AnalyticsFilters } from '../parts'

import type { AnalyticsFunnel, AnalyticsOverview } from '@/types/analytics'

/** Where shoppers give up: the journey, the share kept at each step, and the journey per device. */
export const FunnelTab = ({ o, range, device }: { o?: AnalyticsOverview; range: AnalyticsFilters; device: string }) => {
  const byDevice = useStoreAnalytics<AnalyticsFunnel>('funnel', { ...range, group_by: 'device' })

  return (
    <div className="space-y-4">
      <JourneyChart o={o} />

      {o && o.totals.sessions > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className={titleClass}>Where shoppers drop off</CardTitle>
          </CardHeader>
          <CardContent className="grid grid-cols-2 gap-3 sm:grid-cols-5">
            {o.funnel.slice(1).map((s) => (
              <div key={s.step} className="rounded-lg bg-subdued p-3">
                <p className="text-xs text-muted-foreground">{STEP_LABELS[s.step]}</p>
                <p className="mt-1 text-lg font-semibold tabular-nums text-ink">{s.rate_from_previous}%</p>
                <p className="text-xs tabular-nums text-muted-foreground">{s.drop_off.toLocaleString()} left at this step</p>
              </div>
            ))}
          </CardContent>
        </Card>
      )}

      {device === 'all' && <DeviceFunnelCard q={byDevice} />}
    </div>
  )
}
